<script>
    import {fade} from 'svelte/transition';

    import I18n from '@js/modules/translations';

    import {mapStore} from '@js/stores/mapStore';

    import {applyRideType} from '@js/actions/mapActions';

    import Icon from '@js/components/themes/Icon.svelte';
    import {RIDE_TYPE_ICON} from '@js/components/themes/icons';

    // inline: the icons only, inside a page panel (the planner's reachable zone and loop) that takes the
    // bar's place on the map.
    const {inline = false} = $props();

    const _handleSelect = (rideType) => {
        if (rideType === mapStore.currentRideType) {
            return;
        }

        applyRideType(rideType);
    };

    const MAX_VISIBLE_WAYPOINTS = 5;
    const isSelectorVisible = $derived.by(() => {
        const waypoints = ($mapStore.map?._mapModel?.linePoints || []).filter((point) => !point.computed);
        return waypoints.length <= MAX_VISIBLE_WAYPOINTS;
    });
</script>

{#snippet options()}
    {#each Object.keys(RIDE_TYPE_ICON) as rideType (rideType)}
        <!-- The label span is hidden at small widths, leaving the icon alone:
             name the button itself so it stays announceable. -->
        <button type="button"
                aria-label={I18n.t(`js.ride.enums.ride_type.${rideType}`)}
                class="map-route-type-bar-option"
                class:map-route-type-bar-option-active={$mapStore.currentRideType === rideType}
                aria-pressed={$mapStore.currentRideType === rideType}
                onclick={() => _handleSelect(rideType)}>
            <Icon class="h-4 w-4"
                  icon={RIDE_TYPE_ICON[rideType]}/>
            {#if !inline}
                <span class="map-route-type-bar-option-label">
                    {I18n.t(`js.ride.enums.ride_type.${rideType}`)}
                </span>
            {/if}
        </button>
    {/each}
{/snippet}

{#if isSelectorVisible && inline}
    <div class="map-route-type-inline"
         role="group"
         aria-label={I18n.t('js.maps.route_type_bar.label')}>
        {@render options()}
    </div>
{:else if isSelectorVisible}
    <div id="route-type-bar"
         class="map-route-type-bar"
         transition:fade={{duration: 200}}>
        <span class="map-route-type-bar-label">
            {I18n.t('js.maps.route_type_bar.label')}
        </span>

        <div class="map-route-type-bar-options">
            {@render options()}
        </div>
    </div>
{/if}
